import React from 'react';

import i18n from 'i18next';

import useTitleWithAccountName from '../hooks/useTitleWithAccountName';
import useVideos from '../hooks/useVideos';

import Videos from '../components/videos';

export default () => {
  const {
    browse,
    liveAndUpcoming,
    isLoading,
  } = useVideos();

  useTitleWithAccountName(i18n.t('videos'));

  return (
    <Videos
      browse={{ data: browse?.data }}
      liveAndUpcoming={liveAndUpcoming?.data}
      isLoading={isLoading}
      activeToggle="home"
    />
  );
};
